<style>
	.el-input {
		text-align: left !important;
	}
	.el-form-item__content {
		text-align: left !important;
	}
	.form{
		display: flex;
	}
	.inputs{
		width: 460px !important;
	}
	.el-form-item__label{
		width: 170px;
		text-align: left;
	}
	.cbtn{
		margin-left: 10px !important;
	}
</style>
<template>
	<div class="edit">
		<el-form :model="dynamicValidateForm" ref="dynamicValidateForm"  class="demo-dynamic">
			<el-form-item prop="email" :label="$t('payment.mailbox')" :rules="[
		    { required: true, message: $t('payment.inpmailbox'), trigger: 'blur' },
		    { type: 'email', message: $t('payment.zqmailbox'), trigger: ['blur', 'change'] }
		  ]" class="form">
				<div class="flex_start">
					<el-input v-model="dynamicValidateForm.email" disabled class="inputs"></el-input>
					<el-button type="primary" @click="send" v-if="sendMsg" class="cbtn">{{$t('payment.obtain')}}</el-button>
					<el-button type="info" disabled v-else class="cbtn">{{timer}}{{$t('payment.send')}}</el-button>
				</div>
			</el-form-item>
			<el-form-item :label="$t('payment.code')" prop="code" :rules="[
		    { required: true, message: $t('payment.input'), trigger: 'blur' },
		  ]" class="form">
				<el-input v-model="dynamicValidateForm.code" class="inputs"></el-input>
			</el-form-item>
		<!-- 	<el-form-item :label="$t('modifyPsd.Original')" prop="ypsd" :rules="[
			  { required: true, message: $t('payment.input'), trigger: 'blur' },
			]" class="form">
				<el-input v-model="dynamicValidateForm.ypsd" type="password" class="inputs"></el-input>
			</el-form-item> -->
			<el-form-item :label="$t('modifyPsd.new')" prop="xpsd" :rules="[
			  { required: true, message: $t('payment.input'), trigger: 'blur' },
			]" class="form">
				<el-input v-model="dynamicValidateForm.xpsd" type="password" class="inputs"></el-input>
			</el-form-item>
			<el-form-item >
				<el-button type="primary" @click="onSubmit('dynamicValidateForm')">{{$t('modifyPsd.modify')}}</el-button>
			</el-form-item>
		</el-form>
		<!-- 设置支付密码 -->
		<el-dialog :title="$t('payment.setpassword')" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
			<el-form :model="seeObj" ref="seeObj" label-width="100px" class="demo-dynamic">
				<el-form-item prop="email" :label="$t('payment.mailbox')" :rules="[
		        { required: true, message: $t('payment.inpmailbox'), trigger: 'blur' },
		        { type: 'email', message: $t('payment.zqmailbox'), trigger: ['blur', 'change'] }
		      ]">
					<div class="flex_start">
						<el-input v-model="seeObj.email" disabled></el-input>
						<el-button type="primary" @click="send" v-if="sendMsg">{{$t('payment.obtain')}}</el-button>
						<el-button type="info" disabled v-else>{{timer}}{{$t('payment.send')}}</el-button>
					</div>
				</el-form-item>
				<el-form-item :label="$t('payment.code')" prop="code" :rules="[
		        { required: true, message: $t('payment.input'), trigger: 'blur' },
		      ]">
					<el-input v-model="seeObj.code"></el-input>
				</el-form-item>
				<el-form-item :label="$t('payment.Paymentpassword')" prop="psd" :rules="[
				  { required: true, message:  $t('payment.input'), trigger: 'blur' },
				]">
					<el-input v-model="seeObj.psd" type="password"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="see('seeObj')">{{ $t('payment.setup')}}</el-button>
				</el-form-item>
			</el-form>
		
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				timer: 60,
				sendMsg: true, //是否显示发送验证码
				dynamicValidateForm: {
					code: '',
					email: '',
					ypsd: '',
					xpsd:''
				},
				dialogVisible: false,
				seeObj:{
					code: '',
					email: '',
					psd:''
				}
			};
		},
		mounted() {
			this.dynamicValidateForm.email = JSON.parse(sessionStorage.getItem('user')).email
			this.seeObj.email = JSON.parse(sessionStorage.getItem('user')).email
			this.getUser()
		},
		methods: {
			// 设置支付密码
			see(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let url = '/api/account/setPayPassword'
						let data = {
							code: this.seeObj.code,
							payPassword: this.seeObj.psd,
							token: sessionStorage.getItem('token')
						}
						this.$put(url, data).then(res => {
							if (res.code == 0) {
								this.$message({
									message: this.$t('Tips.setupsuc'),
									type: 'success'
								});
								this.dialogVisible = false
							}
						})
					} else {
						return false;
					}
				});
			},
			// 获取账户信息
			getUser() {
				let url = "/api/account/getAccountAll";
				let data = {
					token: sessionStorage.getItem('token')
				};
				this.$get(url, data).then(res => {
					if (res.code == 0) {
						if (res.data.payPassword == null || !res.data.payPassword) {
							this.dialogVisible = true
						}
					}
				});
			},
			// 修改支付密码
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let url = '/api/account/updatePayPassword'
						let data = {
							code: this.dynamicValidateForm.code,
							// oldPayPassword: this.dynamicValidateForm.ypsd,
							payPassword:this.dynamicValidateForm.xpsd,
							token: sessionStorage.getItem('token')
						}
						this.$put(url, data).then(res => {
							if (res.code == 0) {
								this.$message({
									message: this.$t('Tips.modifysuc'),
									type: 'success'
								});
								setTimeout(()=>{
									 this.$router.go(-1)
								},2000)
							}
						})
					} else {
						return false;
					}
				});
			},
			//发送验证码
			send() {
				if (this.dynamicValidateForm.email == '') {
					this.$message({
						message: this.$t('Tips.mailbox'),
						type: 'error'
					});
				} else {
					let url = '/api/account/sendMail'
					let data = {
						token: sessionStorage.getItem('token')
					}
					this.$get(url, data).then(res => {
						if (res.code == 0) {
							this.$message({
								message: this.$t('Tips.code'),
								type: 'success'
							});
							this.sendMsg = false
							let timerFn = setInterval(() => {
								if (this.timer != 0) {
									this.timer--
								} else {
									this.timer = 60;
									this.sendMsg = true
									clearInterval(timerFn)
								}
							}, 1000)
						} else {
							return
						}
			
					})
				}
			},
		}
	};
</script>
<style scoped>
	.flex_start{
		width: 100%;
	}

	div {
		box-sizing: border-box;
	}

	.edit {
		width: 100%;
		height: 100%;
		padding: 26px 33px;
	}

	.warning {
		display: flex;
		align-items: center;
		background: #fbf7f4;
		height: 40px;
		padding-left: 15px;
		color: #fe4646;
		font-size: 14px;
		margin-bottom: 31px;
	}

	.warning img {
		width: 20px;
		height: 20px;
		margin-right: 9px;
	}

	.list {
		margin-bottom: 20px;
		display: flex;
		align-items: center;
	}

	.inp {
		padding-left: 19px;
		height: 42px;
		margin-left: 19px;
		background: #f6f4f5;
		width: 468px;
		border-radius: 3px;
	}

	.inp.red {
		background: #fef6f2;
		border: 1px solid #fa8772;
	}

	.red_font {
		margin-left: 20px;
		font-size: 14px;
		color: #fa2f0a;
	}

	.name {
		width: 90px;
		text-align: right;
	}

	.btn {
		width: 124px;
		height: 36px;
		background: linear-gradient(0deg,
			rgba(5, 115, 203, 1) 0%,
			rgba(63, 159, 234, 1) 100%);
		border-radius: 2px;
		font-size: 14px;
		line-height: 36px;
		color: #fff;
		margin-left: 19px;
	}
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/sub/paymentPsd.vue